/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    StringIdAndLabel,
    StringIdAndLabelFromJSON,
    StringIdAndLabelFromJSONTyped,
    StringIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BrandAndMarketListItem
 */
export interface BrandAndMarketListItem {
    /**
     * 
     * @type {StringIdAndLabel}
     * @memberof BrandAndMarketListItem
     */
    market?: StringIdAndLabel;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof BrandAndMarketListItem
     */
    brand?: Int32IdAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof BrandAndMarketListItem
     */
    allowEdit?: boolean;
}

export function BrandAndMarketListItemFromJSON(json: any): BrandAndMarketListItem {
    return BrandAndMarketListItemFromJSONTyped(json, false);
}

export function BrandAndMarketListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandAndMarketListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'market': !exists(json, 'market') ? undefined : StringIdAndLabelFromJSON(json['market']),
        'brand': !exists(json, 'brand') ? undefined : Int32IdAndLabelFromJSON(json['brand']),
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function BrandAndMarketListItemToJSON(value?: BrandAndMarketListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'market': StringIdAndLabelToJSON(value.market),
        'brand': Int32IdAndLabelToJSON(value.brand),
        'allowEdit': value.allowEdit,
    };
}


